import { Step } from "../../models/tour.model";
// import * as H from 'history';

const styleDefault = {
  backgroundColor: "#fff",
  borderRadius: "8px"
};
// history: H.History<H.LocationState>,
export function initialTour(openModal: () => void, t: (a: string) => string, closeModal: () => void): Step[] {
    return [
        {
          content: (
            <>
              {
                t("tour.step-1")
              }
            </>
          ),
          selector: "#filter",
          style: { ...styleDefault },
        } as Step,
        {
          content: (
            <>
              {
                t("tour.step-2")
              }
            </>
          ),
          selector: "#result",
          style: { ...styleDefault },
        },
        {
          content: (
            <>
              {
                t("tour.step-3")
              }
            </>
          ),
          selector: "#candidate-0",
          style: { ...styleDefault },
          action: () => closeModal()
        },
        {
          content: (
            <>
              {
                t("tour.step-4")
              }
            </>
          ),
          selector: "#modal-title",
          style: { ...styleDefault },
          action: () => openModal()
        },
        {
          content: (
            <>
               {
                t("tour.step-5")
              }
            </>
          ),
          selector: "#unlock-candidate",
          style: { ...styleDefault },
          position: "bottom",
        }
      ] as Step[];
}

export function vacancieTour(): Step[] {
  return [
    {
      content: (
        <>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Quibusdam
        </>
      ),
      selector: "#add-job",
      style: { ...styleDefault }
    }
  ];
};

export function selectiveProcessTour(): Step[] {
  return [
    {
      content: (
        <>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Quibusdam
        </>
      ),
      selector: "#filters",
      style: { ...styleDefault }
    }
  ];
};

export function teamTour(): Step[] {
  return [
    {
      content: (
        <>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Quibusdam
        </>
      ),
      selector: "#company-infos",
      style: { ...styleDefault }
    }
  ];
};